export function initMegamenu($) {
  $(".header_mid li.menu-item-has-children").hover(
    function () {
      $(this).find(".megamenu").stop().fadeIn(250);
      $(".header").addClass("megamenu-open");
    },
    function () {
      $(this).find(".megamenu").stop().fadeOut(200);
      $(".header").removeClass("megamenu-open");
    },
  );
}
